import React from "react";
import ResultsList from "./ResultsList";

// Phase 3 (M2): Résultats par locataire — reference PDF page 35, which is
// table-only (no graph page). Per-lease rows grouped by tenant with tenant
// subtotals + grand total. Thin wrapper over the shared ResultsList (grouped by
// tenant_name), with charts disabled to match the reference.
const ResultsPerTenant = (props) => (
  <ResultsList
    {...props}
    sectionTitle="Résultats par locataire"
    groupOf={(o) => String(o.tenant_name || "Vacant")}
    subtotalKey="tenant_name"
    showCharts={false}
  />
);

export default ResultsPerTenant;
